import { useState, useEffect } from 'react';
import {
  Building2,
  Plus,
  ChevronDown,
  ChevronUp,
  Edit,
  Trash2,
  MapPin,
  User,
  Phone,
  Mail,
  X,
  Save,
  Loader2,
  Home,
  FileText,
  ExternalLink,
  AlertCircle,
  Clock,
  CheckCircle
} from '../../icons/wp-icons';
import { objektApi } from '../../api/objektApi';
import toast from 'react-hot-toast';

const OBJEKT_TYPEN = [
  { value: 'MEHRFAMILIENHAUS', label: 'Mehrfamilienhaus' },
  { value: 'EINFAMILIENHAUS', label: 'Einfamilienhaus' },
  { value: 'GEWERBE', label: 'Gewerbe' },
  { value: 'BUERO', label: 'Büro' },
  { value: 'SONSTIGES', label: 'Sonstiges' }
];

const AP_ROLLEN = [
  { value: 'MIETER', label: 'Mieter' },
  { value: 'HAUSMEISTER', label: 'Hausmeister' },
  { value: 'VERWALTER', label: 'Verwalter' },
  { value: 'EIGENTUEMER', label: 'Eigentümer' },
  { value: 'SONSTIGES', label: 'Sonstiges' }
];

function ObjektForm({ initial, onSave, onCancel, saving }) {
  const [form, setForm] = useState({
    name: initial?.name || '',
    strasse: initial?.strasse || '',
    plz: initial?.plz || '',
    ort: initial?.ort || '',
    typ: initial?.typ || '',
    notizen: initial?.notizen || ''
  });

  return (
    <div className="bg-gray-50 rounded-lg p-4 space-y-3">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Straße + Nr. *</label>
          <input type="text" value={form.strasse} onChange={e => setForm(f => ({ ...f, strasse: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-1 focus:ring-primary focus:border-primary"
            placeholder="Musterstraße 12" />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Kurzname</label>
          <input type="text" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-1 focus:ring-primary focus:border-primary"
            placeholder="z.B. Objekt Musterstraße" />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">PLZ</label>
          <input type="text" value={form.plz} onChange={e => setForm(f => ({ ...f, plz: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-1 focus:ring-primary focus:border-primary"
            placeholder="50667" />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Ort</label>
          <input type="text" value={form.ort} onChange={e => setForm(f => ({ ...f, ort: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-1 focus:ring-primary focus:border-primary"
            placeholder="Köln" />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Typ</label>
          <select value={form.typ} onChange={e => setForm(f => ({ ...f, typ: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-1 focus:ring-primary focus:border-primary">
            <option value="">Nicht angegeben</option>
            {OBJEKT_TYPEN.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
        </div>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Notizen</label>
        <textarea value={form.notizen} onChange={e => setForm(f => ({ ...f, notizen: e.target.value }))} rows="2"
          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-1 focus:ring-primary focus:border-primary"
          placeholder="Besonderheiten zum Objekt..." />
      </div>
      <div className="flex gap-2 justify-end">
        <button onClick={onCancel} className="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-800" disabled={saving}>Abbrechen</button>
        <button onClick={() => onSave(form)} disabled={saving || !form.strasse.trim()}
          className="px-4 py-1.5 text-sm bg-primary text-white rounded-lg hover:bg-primary-dark disabled:opacity-50 flex items-center gap-1">
          {saving ? <Loader2 className="w-3 h-3 animate-spin" /> : <Save className="w-3 h-3" />}
          Speichern
        </button>
      </div>
    </div>
  );
}

function AnsprechpartnerForm({ initial, onSave, onCancel, saving }) {
  const [form, setForm] = useState({
    name: initial?.name || '',
    telefon: initial?.telefon || '',
    email: initial?.email || '',
    rolle: initial?.rolle || '',
    wohneinheit: initial?.wohneinheit || '',
    notizen: initial?.notizen || ''
  });

  return (
    <div className="bg-blue-50 rounded-lg p-3 space-y-2 mt-2">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Name *</label>
          <input type="text" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
            className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-1 focus:ring-primary" placeholder="Hr. Schmidt" />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Rolle</label>
          <select value={form.rolle} onChange={e => setForm(f => ({ ...f, rolle: e.target.value }))}
            className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-1 focus:ring-primary">
            <option value="">Nicht angegeben</option>
            {AP_ROLLEN.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Telefon</label>
          <input type="tel" value={form.telefon} onChange={e => setForm(f => ({ ...f, telefon: e.target.value }))}
            className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-1 focus:ring-primary" placeholder="+49 123 456789" />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">E-Mail</label>
          <input type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
            className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-1 focus:ring-primary" placeholder="schmidt@example.de" />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Wohneinheit</label>
          <input type="text" value={form.wohneinheit} onChange={e => setForm(f => ({ ...f, wohneinheit: e.target.value }))}
            className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-1 focus:ring-primary" placeholder="WE 3 / EG links" />
        </div>
      </div>
      <div className="flex gap-2 justify-end">
        <button onClick={onCancel} className="px-3 py-1 text-xs text-gray-600 hover:text-gray-800" disabled={saving}>Abbrechen</button>
        <button onClick={() => onSave(form)} disabled={saving || !form.name.trim()}
          className="px-3 py-1 text-xs bg-primary text-white rounded-lg hover:bg-primary-dark disabled:opacity-50 flex items-center gap-1">
          {saving ? <Loader2 className="w-3 h-3 animate-spin" /> : <Save className="w-3 h-3" />}
          Speichern
        </button>
      </div>
    </div>
  );
}

function RolleBadge({ rolle }) {
  const config = {
    MIETER: { label: 'Mieter', bg: 'bg-blue-100 text-blue-700' },
    HAUSMEISTER: { label: 'Hausmeister', bg: 'bg-amber-100 text-amber-700' },
    VERWALTER: { label: 'Verwalter', bg: 'bg-purple-100 text-purple-700' },
    EIGENTUEMER: { label: 'Eigentümer', bg: 'bg-green-100 text-green-700' },
    SONSTIGES: { label: 'Sonstiges', bg: 'bg-gray-100 text-gray-700' }
  };
  const c = config[rolle] || config.SONSTIGES;
  return <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium ${c.bg}`}>{c.label}</span>;
}

function TypBadge({ typ }) {
  const label = OBJEKT_TYPEN.find(t => t.value === typ)?.label || typ || 'Objekt';
  return <span className="text-[10px] px-1.5 py-0.5 rounded-full font-medium bg-gray-100 text-gray-600">{label}</span>;
}

export default function ObjekteSection({ kundeId, initialObjekte, anfragen, readOnly, onScrollToAnfrage }) {
  const [objekte, setObjekte] = useState(initialObjekte || []);
  const [expanded, setExpanded] = useState({});
  const [showNewObjekt, setShowNewObjekt] = useState(false);
  const [editingObjekt, setEditingObjekt] = useState(null);
  const [saving, setSaving] = useState(false);
  const [showNewAp, setShowNewAp] = useState({}); // { objektId: true }
  const [editingAp, setEditingAp] = useState(null);

  useEffect(() => {
    if (initialObjekte) setObjekte(initialObjekte);
  }, [initialObjekte]);

  const loadObjekte = async () => {
    try {
      const res = await objektApi.getByKunde(kundeId);
      setObjekte(res.data);
    } catch (err) {
      console.error('Fehler beim Laden der Objekte:', err);
    }
  };

  const handleCreateObjekt = async (form) => {
    setSaving(true);
    try {
      await objektApi.create({ ...form, kundeId });
      await loadObjekte();
      setShowNewObjekt(false);
      toast.success('Objekt erstellt');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Fehler beim Erstellen');
    } finally {
      setSaving(false);
    }
  };

  const handleUpdateObjekt = async (form) => {
    setSaving(true);
    try {
      await objektApi.update(editingObjekt, form);
      await loadObjekte();
      setEditingObjekt(null);
      toast.success('Objekt aktualisiert');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Fehler beim Aktualisieren');
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteObjekt = async (id) => {
    if (!confirm('Objekt wirklich deaktivieren?')) return;
    try {
      await objektApi.delete(id);
      await loadObjekte();
      toast.success('Objekt deaktiviert');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Fehler beim Löschen');
    }
  };

  const handleCreateAp = async (objektId, form) => {
    setSaving(true);
    try {
      await objektApi.createAnsprechpartner({ ...form, objektId });
      await loadObjekte();
      setShowNewAp({});
      toast.success('Ansprechpartner erstellt');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Fehler beim Erstellen');
    } finally {
      setSaving(false);
    }
  };

  const handleUpdateAp = async (form) => {
    setSaving(true);
    try {
      await objektApi.updateAnsprechpartner(editingAp, form);
      await loadObjekte();
      setEditingAp(null);
      toast.success('Ansprechpartner aktualisiert');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Fehler beim Aktualisieren');
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteAp = async (id) => {
    if (!confirm('Ansprechpartner wirklich entfernen?')) return;
    try {
      await objektApi.deleteAnsprechpartner(id);
      await loadObjekte();
      toast.success('Ansprechpartner entfernt');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Fehler beim Löschen');
    }
  };

  const toggleExpand = (id) => {
    setExpanded(prev => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div>
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-semibold flex items-center gap-2">
          <Building2 className="w-5 h-5 text-primary" />
          Objekte ({objekte.length})
        </h3>
        {!readOnly && (
          <button onClick={() => setShowNewObjekt(!showNewObjekt)}
            className="flex items-center gap-1 px-3 py-1.5 text-sm bg-primary text-white rounded-lg hover:bg-primary-dark">
            {showNewObjekt ? <X className="w-3.5 h-3.5" /> : <Plus className="w-3.5 h-3.5" />}
            {showNewObjekt ? 'Abbrechen' : 'Neues Objekt'}
          </button>
        )}
      </div>

      {/* Neues Objekt Formular */}
      {showNewObjekt && (
        <div className="mb-4">
          <ObjektForm onSave={handleCreateObjekt} onCancel={() => setShowNewObjekt(false)} saving={saving} />
        </div>
      )}

      {/* Objekte Liste */}
      {objekte.length === 0 && !showNewObjekt ? (
        <p className="text-text-muted text-sm">Keine Objekte vorhanden. Fügen Sie ein Gebäude/eine Adresse hinzu.</p>
      ) : (
        <div className="space-y-3">
          {objekte.map(objekt => (
            <div key={objekt.id} className="border border-gray-200 rounded-lg overflow-hidden">
              {/* Objekt Header */}
              <div
                className="flex items-center justify-between px-4 py-3 bg-white cursor-pointer hover:bg-gray-50"
                onClick={() => toggleExpand(objekt.id)}
              >
                <div className="flex items-center gap-3 min-w-0">
                  <MapPin className="w-4 h-4 text-primary flex-shrink-0" />
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="font-medium text-sm truncate">
                        {objekt.name || objekt.strasse}
                      </span>
                      {objekt.typ && <TypBadge typ={objekt.typ} />}
                    </div>
                    <div className="text-xs text-gray-500">
                      {objekt.strasse}{objekt.plz || objekt.ort ? `, ${[objekt.plz, objekt.ort].filter(Boolean).join(' ')}` : ''}
                      {objekt.ansprechpartner?.length > 0 && (
                        <span className="ml-2">
                          · {objekt.ansprechpartner.length} Ansprechpartner
                        </span>
                      )}
                      {(objekt._count?.anfragen > 0 || objekt._count?.termine > 0) && (
                        <span className="ml-2">
                          · {objekt._count?.anfragen || 0} Anfragen · {objekt._count?.termine || 0} Termine
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-1">
                  {!readOnly && (
                    <>
                      <button onClick={(e) => { e.stopPropagation(); setEditingObjekt(objekt.id); setExpanded(prev => ({ ...prev, [objekt.id]: true })); }}
                        className="p-1.5 text-gray-400 hover:text-primary rounded">
                        <Edit className="w-3.5 h-3.5" />
                      </button>
                      <button onClick={(e) => { e.stopPropagation(); handleDeleteObjekt(objekt.id); }}
                        className="p-1.5 text-gray-400 hover:text-red-500 rounded">
                        <Trash2 className="w-3.5 h-3.5" />
                      </button>
                    </>
                  )}
                  {expanded[objekt.id] ? <ChevronUp className="w-4 h-4 text-gray-400" /> : <ChevronDown className="w-4 h-4 text-gray-400" />}
                </div>
              </div>

              {/* Expanded Content */}
              {expanded[objekt.id] && (
                <div className="border-t border-gray-200 px-4 py-3 bg-gray-50">
                  {/* Edit Objekt */}
                  {editingObjekt === objekt.id ? (
                    <div className="mb-3">
                      <ObjektForm initial={objekt} onSave={handleUpdateObjekt} onCancel={() => setEditingObjekt(null)} saving={saving} />
                    </div>
                  ) : objekt.notizen ? (
                    <p className="text-xs text-gray-500 mb-3 italic">{objekt.notizen}</p>
                  ) : null}

                  {/* Verknüpfte Anfragen */}
                  {(() => {
                    const objektAnfragen = anfragen?.filter(a => a.objektId === objekt.id) || [];
                    if (objektAnfragen.length === 0) return null;
                    const statusIcon = { neu: AlertCircle, in_bearbeitung: Clock, abgeschlossen: CheckCircle };
                    const statusColor = { neu: 'text-blue-600', in_bearbeitung: 'text-yellow-600', abgeschlossen: 'text-green-600' };
                    return (
                      <div className="mb-3">
                        <div className="flex items-center gap-1 mb-2">
                          <FileText className="w-3 h-3 text-purple-500" />
                          <span className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Anfragen ({objektAnfragen.length})</span>
                        </div>
                        <div className="space-y-1">
                          {objektAnfragen.map(a => {
                            const Icon = statusIcon[a.status] || AlertCircle;
                            const color = statusColor[a.status] || 'text-gray-500';
                            return (
                              <button
                                key={a.id}
                                type="button"
                                onClick={(e) => { e.stopPropagation(); onScrollToAnfrage?.(a.id); }}
                                className="w-full flex items-center gap-2 px-3 py-1.5 bg-white rounded-lg text-sm hover:bg-purple-50 transition text-left group"
                              >
                                <Icon className={`w-3.5 h-3.5 ${color} shrink-0`} />
                                <span className="truncate flex-1">{a.betreff}</span>
                                <ExternalLink className="w-3 h-3 text-gray-300 group-hover:text-purple-500 shrink-0" />
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })()}

                  {/* Ansprechpartner */}
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Ansprechpartner</span>
                    {!readOnly && (
                      <button onClick={() => setShowNewAp(prev => ({ ...prev, [objekt.id]: !prev[objekt.id] }))}
                        className="text-xs text-primary hover:text-primary-dark flex items-center gap-1">
                        <Plus className="w-3 h-3" /> Hinzufügen
                      </button>
                    )}
                  </div>

                  {objekt.ansprechpartner?.length > 0 ? (
                    <div className="space-y-2">
                      {objekt.ansprechpartner.map(ap => (
                        editingAp === ap.id ? (
                          <AnsprechpartnerForm key={ap.id} initial={ap} onSave={handleUpdateAp} onCancel={() => setEditingAp(null)} saving={saving} />
                        ) : (
                          <div key={ap.id} className="flex items-center justify-between bg-white rounded-lg px-3 py-2 text-sm">
                            <div className="flex items-center gap-3 min-w-0">
                              <User className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
                              <div className="min-w-0">
                                <div className="flex items-center gap-2">
                                  <span className="font-medium text-sm">{ap.name}</span>
                                  {ap.rolle && <RolleBadge rolle={ap.rolle} />}
                                  {ap.wohneinheit && <span className="text-[10px] text-gray-500">{ap.wohneinheit}</span>}
                                </div>
                                <div className="flex gap-3 text-xs text-gray-500 mt-0.5">
                                  {ap.telefon && <span className="flex items-center gap-1"><Phone className="w-3 h-3" />{ap.telefon}</span>}
                                  {ap.email && <span className="flex items-center gap-1"><Mail className="w-3 h-3" />{ap.email}</span>}
                                </div>
                              </div>
                            </div>
                            {!readOnly && (
                              <div className="flex items-center gap-1 flex-shrink-0">
                                <button onClick={() => setEditingAp(ap.id)} className="p-1 text-gray-400 hover:text-primary">
                                  <Edit className="w-3 h-3" />
                                </button>
                                <button onClick={() => handleDeleteAp(ap.id)} className="p-1 text-gray-400 hover:text-red-500">
                                  <Trash2 className="w-3 h-3" />
                                </button>
                              </div>
                            )}
                          </div>
                        )
                      ))}
                    </div>
                  ) : (
                    <p className="text-xs text-gray-400">Noch keine Ansprechpartner hinterlegt.</p>
                  )}

                  {/* Neuer Ansprechpartner Formular */}
                  {showNewAp[objekt.id] && (
                    <AnsprechpartnerForm
                      onSave={(form) => handleCreateAp(objekt.id, form)}
                      onCancel={() => setShowNewAp(prev => ({ ...prev, [objekt.id]: false }))}
                      saving={saving}
                    />
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
